export function dataInRequest(params = {}) {
  return {
    type: '@causasManutencoes/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@causasManutencoes/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@causasManutencoes/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@causasManutencoes/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@causasManutencoes/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@causasManutencoes/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@causasManutencoes/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@causasManutencoes/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@causasManutencoes/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@causasManutencoes/RECORD_FILTERING',
    payload: { params },
  };
}
